import { initializeApp } from "firebase/app";
import { AppContext, AuthContext, NavbarControllerContext, SidebarControllerContext, useApp, useNavbarController } from "../GlobalData";
import { getAuth, User } from "firebase/auth";
import { JSX, useEffect, useRef, useState } from "react";
import "./index.scss"
import { DefaultNavbar } from "../common/navbar";
import { DefaultSidebarApplier } from "../common/sidebar";
import { MurmurHash3 } from "murmurhash-wasm";

const firebaseConfig = {

    apiKey: "AIzaSyDbAiI6x0d840ggw2UC2QxRxjepaRDtFIw",

    authDomain: "elearningntt.firebaseapp.com",

    databaseURL: "https://elearningntt-default-rtdb.asia-southeast1.firebasedatabase.app",

    projectId: "elearningntt",

    storageBucket: "elearningntt.firebasestorage.app",

    messagingSenderId: "792833896208",

    appId: "1:792833896208:web:483f41a88431e98e52bf95",

    measurementId: "G-SGXXFR67QJ"

};

function AddAppContext({ children }: { children: JSX.Element | JSX.Element[] }) {
    const app = initializeApp(firebaseConfig);
    return <AppContext.Provider value={app}>
        {children}
    </AppContext.Provider>
}

function AddAuthContext({ children }: { children: JSX.Element | JSX.Element[] }) {
    const { app } = useApp();
    const auth = getAuth(app);
    const [user, setUser] = useState(null as User | null);
    useEffect(() => {
        return auth.onAuthStateChanged((x) => {
            setUser(x);
        })
    }, [])
    const value = {
        auth,
        user
    }
    return <AuthContext.Provider value={value}>
        {children}
    </AuthContext.Provider>
}

type AnyFunctionSafer = (...args: unknown[]) => unknown;

const getFunctionID = (func: AnyFunctionSafer) => MurmurHash3.hash32(func.toString(), 0).toString('hex');

export function useElementDepth(): [React.Ref<HTMLDivElement>, number] {
    const [depth, setDepth] = useState(0);
    const elementRef: React.Ref<HTMLDivElement> = useRef(null);

    useEffect(() => {
        let element: HTMLDivElement | HTMLElement | null = elementRef.current;
        if (!element) return;

        let count = 0;
        while (element != null && element.parentElement) {
            count++;
            element = element.parentElement;
        }
        setDepth(count);
    }, []); // Run once on mount

    // Return the ref and the depth
    return [elementRef, depth];
}

function NavBarController({ children }: { children: JSX.Element | JSX.Element[] }) {
    const [currentNavbars, setCurrentNavbars]: [{
        id: string;
        navbar: () => JSX.Element;
        depth: number;
    }[], React.Dispatch<React.SetStateAction<{
        id: string;
        navbar: () => JSX.Element;
        depth: number;
    }[]>>] = useState([] as {
        id: string;
        navbar: () => JSX.Element;
        depth: number;
    }[])
    const currentNavbarsRef = useRef([] as {
        id: string;
        navbar: () => JSX.Element;
        depth: number;
    }[]);
    const navbarController = {
        queueNavbar: (depth: number, func: () => JSX.Element): () => void => {
            const hashedid = getFunctionID(func);
            const entries1 = currentNavbarsRef.current.map((x, i) => [i, x] as [number, {
                id: string;
                navbar: () => JSX.Element;
                depth: number;
            }]).filter(x => x[1].id == hashedid)
            if (entries1.length > 0) {
                const copied = [...currentNavbarsRef.current]
                copied[entries1[0][0]] = {
                    id: hashedid,
                    navbar: func,
                    depth
                };
                currentNavbarsRef.current = copied;
                console.log("conflict")
                return () => {
                    const filtered = [...currentNavbarsRef.current].filter(x => x.id != hashedid);
                    currentNavbarsRef.current = filtered;
                    setCurrentNavbars(filtered)
                }
            }
            const current = [...currentNavbarsRef.current]
            current.push({
                id: hashedid,
                navbar: func,
                depth
            })

            setCurrentNavbars(current);
            currentNavbarsRef.current = current;
            return () => {
                const filtered = [...currentNavbarsRef.current].filter(x => x.id != hashedid);
                currentNavbarsRef.current = filtered;
                setCurrentNavbars(filtered)
            };
        },
        removeNavbar: (id: string) => {
            const filtered = [...currentNavbarsRef.current].filter(x => x.id != id);

            currentNavbarsRef.current = filtered;

            setCurrentNavbars(filtered)
        }
    }
    const copied = [...currentNavbars]
    copied.sort((a, b) => b.depth - a.depth);
    const selected = copied[0] ?? {
        depth: 0,
        id: "default",
        navbar: () => <></>
    }

    //console.log(currentNavbars)
    return <NavbarControllerContext.Provider value={navbarController}>
        <div className="flex flex-col ">
            <div className="flex flex-row w-full h-max">{selected.navbar()}</div>
            <div>{children}</div>
        </div>
    </NavbarControllerContext.Provider>
}


function SideBarController({ children }: { children: JSX.Element | JSX.Element[] }) {
    const [currentSidebars, setCurrentSidebars]: [{
        id: string;
        sidebar: () => JSX.Element;
        depth: number;
    }[], React.Dispatch<React.SetStateAction<{
        id: string;
        sidebar: () => JSX.Element;
        depth: number;
    }[]>>] = useState([] as {
        id: string;
        sidebar: () => JSX.Element;
        depth: number;
    }[])
    const [sidebarOpen, setSidebarState] = useState(false);

    const currentSidebarsRef = useRef([] as {
        id: string;
        sidebar: () => JSX.Element;
        depth: number;
    }[]);
    const sidebarController = {
        queueSidebar: (depth: number, func: () => JSX.Element): () => void => {
            const hashedid = getFunctionID(func);
            const entries1 = currentSidebarsRef.current.map((x, i) => [i, x] as [number, {
                id: string;
                sidebar: () => JSX.Element;
                depth: number;
            }]).filter(x => x[1].id == hashedid)
            if (entries1.length > 0) {
                const copied = [...currentSidebarsRef.current]
                copied[entries1[0][0]] = {
                    id: hashedid,
                    sidebar: func,
                    depth
                };
                currentSidebarsRef.current = copied;
                return () => {
                    const filtered = [...currentSidebarsRef.current].filter(x => x.id != hashedid);
                    currentSidebarsRef.current = filtered
                    setCurrentSidebars(filtered)
                };
            }
            const current = [...currentSidebarsRef.current]
            current.push({
                id: hashedid,
                sidebar: func,
                depth
            })
            setCurrentSidebars(current);
            currentSidebarsRef.current = current;
            return () => {
                const filtered = [...currentSidebarsRef.current].filter(x => x.id != hashedid);
                currentSidebarsRef.current = filtered
                setCurrentSidebars(filtered)
            };
        },
        removeSidebar: (id: string) => {
            const filtered = [...currentSidebarsRef.current].filter(x => x.id != id);
            currentSidebarsRef.current = filtered
            setCurrentSidebars(filtered)
        },
        getSidebarState: () => sidebarOpen,
        setSidebarState
    }
    const copied = [...currentSidebars]
    copied.sort((a, b) => b.depth - a.depth);
    const selected = copied[0] ?? {
        depth: 0,
        id: "default",
        sidebar: () => <></>
    }
    return <SidebarControllerContext.Provider value={sidebarController}>
        <div className={`flex flex-row w-full ${sidebarOpen ? `h-[100dvh] w-[100dvh] overflow-hidden` : `h-max`}`}>
            <div className={`flex flex-row bg-white sidebar ${sidebarOpen ? `sidebaropen` : `sidebarclosed`}  overflow-y-scroll overflow-x-hidden`}>{selected.sidebar()}</div>
            <div className="top-0 left-0 relative w-full">
                <div className={`w-full sidebarshade h-full ${sidebarOpen ? "z-1 opacity-50 bg-black" : ""}`} />
                <div className={`w-full h-full relative top-[-100%] ${sidebarOpen ? "z-[-1] overflow-clip" : ""}`}>

                    {children}
                </div>
            </div>
        </div>
    </SidebarControllerContext.Provider>
}

export function DefaultNavbarApplier({ children }: { children: JSX.Element | JSX.Element[] }) {
    const controller = useNavbarController()
    const [ref2, depth] = useElementDepth()

    useEffect(() => {
        return controller.queueNavbar(depth, () => <><DefaultNavbar /></>)
    }, [depth])
    return <div ref={ref2}>
        {children}
    </div>
}

export function GlobalProviders({ children }: { children: JSX.Element | JSX.Element[] }) { // Wraps App, User and theme contexts
    return <AddAppContext>
        <AddAuthContext>
            <SideBarController>
                <NavBarController>
                    <DefaultSidebarApplier>
                        <DefaultNavbarApplier>
                            {children}
                        </DefaultNavbarApplier>
                    </DefaultSidebarApplier>
                </NavBarController>
            </SideBarController>
        </AddAuthContext>
    </AddAppContext>
}